import React, { useEffect } from "react";
import {  CreateFylloFertigationReport, ScreenHeader } from "react-library";
import {  useNavigate, useParams } from "react-router-dom";
import { getAccessToken } from "../../services/common.service";
import { TLang, t } from "../../services/locale.service";
import "./create-fertigation.css";

const CreateFertigationReport: React.FC = () => {
  const { plotId } = useParams();
  const token = getAccessToken();
  const language = localStorage.getItem("user_language") as TLang;
  const headerTitle = `${t("fertigation")} ${t("Report")}`;
  const farmUserId = localStorage.getItem("farmUserId");
  const navigate = useNavigate();
 
  useEffect(() => {
    const handleBackIconPress = () => {
      handleBack();
    };

    window.addEventListener("back-icon-press", handleBackIconPress);

    return () => {
      window.removeEventListener("back-icon-press", handleBackIconPress);
    };
  }, [navigate]);

  const onSuccessfullReportUpload = () => {
    try {
      handleBack();
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleBack = () => {
    try {
      navigate(-1);  
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="cfr-container">
      <ScreenHeader screenName={headerTitle} />
      {plotId && farmUserId && (
        <CreateFylloFertigationReport 
          plotId={plotId}
          token={token}
          language={language ?? "en"}
          farmUserId={farmUserId}
          reportAddedCallback={onSuccessfullReportUpload}
        />
      )}
      {/* <FylloCreateFertigationReport
            plotId={plotId}
            token={token}
            language={language ?? "en"}
            farmUserId={farmUserId}
            fertigationReport={state?.report}
          /> */}
     
    </div>
  );
};

export default CreateFertigationReport;